import React from "react";
import AboutPic from "../images/about.jpg";

function About() {
  return (
    <>
      <div className=" relative mt-[8rem] mx-4">
        <h1 className="text-[11rem] opacity-10 font-bold hidden md:block absolute top-[-2.5rem]">
          about
        </h1>
        <h2 className="text-[2.5rem] md:pt-[8rem] md:pl-[20rem] border-b border-white mr-[6rem] pl-6 md:border-none">
          about us
        </h2>
        <div className="md:flex mx-2 lg:mx-[4rem] xl:mx-[10rem]">
          <div className=" text-[3rem] my-[2rem] leading-10 md:pt-10">
            Welcome to The Tattoo, where art meets{" "}
            <span className="text-[#ff4e00]">passion.</span>
          </div>
          <div className="md:w-[100%] lg:ml-10 xl:ml-[10rem]">
            <p className="text-[1.5rem] leading-8 mb-4">
              At The Tattoo, we believe in creating more than just tattoos; we
              create lifelong memories. Our team of skilled artists is dedicated
              to bringing your vision to life with precision and care.
            </p>
            <p className="text-[1.3rem] leading-6 text-[#6a6a6a] lg:mt-[3rem]">
              From custom designs to walk-in appointments, we cater to all your
              tattoo needs. Our studio is a safe and welcoming space for
              everyone, ensuring that your experience is as unique as your
              tattoo.
            </p>
          </div>
        </div>
        <div className="my-6 md:flex justify-between lg:mx-[5rem] relative">
          <img
            className="rounded-lg opacity-60 hover:opacity-100 hover:duration-300 md:w-1/2 md:mr-10 lg:w-[40%] lg:mx-10 hover:scale-105 max-h-[35rem] object-cover"
            src={AboutPic}
            alt="about"
          />
          <div className="my-4 md:flex md:flex-col justify-center">
            <p className="italic text-xl text-center bg-[#5d5d5d] text-[#fff] p-2 rounded-xl mx-5 xl:mx-10 hover:duration-300 vibrateQuote hover:scale-110">
              "At this tattoo studio, we don't just ink skin; we create art that tells
              your story. Our dedication to excellence is unmatched."
            </p>
            <p className="text-[#6a6a6a] text-center text-2xl mt-6">
              - someone probably
            </p>
            <p className="text-[#000000] text-center text-2xl mt-2">
              inkhouse founder / artist
            </p>
            <a href="https://form.jotform.com/211304498108856" target="_blank" rel="noreferrer" className="hidden md:block absolute right-12 bottom-0 border-2 rounded-md py-2 px-10 border-[#6a6a6a] hover:border-[#ff4e00] hover:duration-500 hover:cursor-pointer uppercase hover:scale-125">
              Book now
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default About;
